'use strict';

export default function DonationOpportunitiesSlider() {
	const sliders = document.querySelectorAll('.donation-opportunities-slider');
	if (!sliders.length) return;

	sliders.forEach((container) => {
		const track = container.querySelector('.donation-opportunities-slider__track');
		const slides = container.querySelectorAll('.donation-opportunities-slider__slide');
		const prevBtn = container.querySelector('.donation-opportunities-slider__prev');
		const nextBtn = container.querySelector('.donation-opportunities-slider__next');

		if (!track || slides.length < 2) {
			if (prevBtn) prevBtn.style.display = 'none';
			if (nextBtn) nextBtn.style.display = 'none';
			return;
		}

		const slidesToShow = +(container.dataset.slidesToShow || 2);
		let currentIndex = 0;

		function getSlidesPerView() {
			return window.innerWidth < 768 ? 1 : slidesToShow;
		}

		function getMaxIndex() {
			return Math.max(0, slides.length - getSlidesPerView());
		}

		function updateSlider() {
			const perView = getSlidesPerView();
			const gap = perView > 1 ? 16 : 0;
			const containerWidth = container.clientWidth;
			const slideWidth = (containerWidth - gap * (perView - 1)) / perView;

			slides.forEach((slide) => {
				slide.style.minWidth = `${slideWidth}px`;
				slide.style.maxWidth = `${slideWidth}px`;
			});

			const offset = currentIndex * (slideWidth + gap);
			track.style.transform = `translateX(-${offset}px)`;

			if (prevBtn) prevBtn.disabled = currentIndex <= 0;
			if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
		}

		function goNext() {
			if (currentIndex < getMaxIndex()) {
				currentIndex++;
				updateSlider();
			}
		}

		function goPrev() {
			if (currentIndex > 0) {
				currentIndex--;
				updateSlider();
			}
		}

		if (nextBtn) nextBtn.addEventListener('click', goNext);
		if (prevBtn) prevBtn.addEventListener('click', goPrev);

		window.addEventListener('resize', () => {
			currentIndex = Math.min(currentIndex, getMaxIndex());
			updateSlider();
		});

		updateSlider();
	});
}
